import React from "react";

const RetireContent = () => {
  return (
    <div className="my-16 mx-16 py-10 rounded-2xl text-center border">
      <div>
        <h3 className="mb-8 text-themeColor">How to retire in Thailand</h3>
      </div>
      <div
        className="my-20 text-medium font-medium"
        style={{ paddingLeft: "30px", paddingRight: "30px" }}
      >
        <p className="my-8">
          Thailand offers a unique and attractive option for retirees looking
          for a change of pace. With its warm climate, beautiful beaches, and
          low cost of living, it's no surprise that many people are choosing to
          spend their golden years in this tropical paradise. Whether you're
          looking to downsize and live a more simple lifestyle, or you're
          seeking adventure and new experiences, retiring in Thailand can be a
          dream come true. Here are a few tips to help you plan for your
          retirement in Thailand:Investigate the cost of living in the areas
          you're interested in. Research retirement visa options and
          requirements.Look into healthcare options.Learn about the culture,
          customs, and language. Explore the real estate market and find the
          perfect property for you.At our real estate agency, we are dedicated
          to helping you make your retirement dreams a reality. With our
          extensive knowledge of the local market and our connections to a wide
          range of service providers, we can assist you with every aspect of
          your move, from finding the perfect property to obtaining your
          retirement visa. Contact us today to learn more about retiring in
          Thailand and start planning for the next chapter of your life.
        </p>
      </div>
    </div>
  );
};

export default RetireContent;
